import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../app/guards'
import { CustomerGroupsPage } from '../../features/customers/customer-groups-page'

export const Route = createFileRoute('/_app/customer-groups')({
  staticData: { crumb: 'customerGroups' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'customers.read'),
  component: CustomerGroupsPage,
})
